import { createAction } from '@reduxjs/toolkit';

export const changeFitler = createAction('contacts/filter');
